import { Component,OnInit, } from '@angular/core';
import { NavigationComponent } from './Common/navigation/navigation.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ChatbotComponent } from './Common/chatbot/chatbot.component';
import { SideNavComponent } from './Common/side-nav/side-nav.component';
import { LoginRegisterComponent } from './login-register/login-register.component';
import { AppstateService } from './services/appstate.service';
import { AuthServiceService } from './services/auth-service.service';
@Component({
  selector: 'app-root',
  imports: [NavigationComponent, RouterModule, CommonModule, ChatbotComponent, SideNavComponent, LoginRegisterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent  implements OnInit{
  isExpanded: boolean = false;
  UserDetails: object | undefined | null;
  version : string = "1.4.5";
  constructor(private appstateService: AppstateService, private _authService: AuthServiceService) {
    this.onChangeSidebar();
  }
  ngOnInit(): void {
    this.UserDetails = this._authService.getUserSession();
  }
  
  private onChangeSidebar(): void {
    this.appstateService.isAppSideBar.subscribe({
      next: (res: boolean) => {
        this.isExpanded = res;
      }
    })
  }

  checkLogIn(){
    return this._authService.isLogedIn();
  }

  
}
